<template>
	<DialogFormDialog ref="dialog" :strings="strings" @reset="reset">
		<v-row>
			<v-col cols="6">
				<v-select v-model="values.dateType" :rules="rules" :items="dateTypes" />
			</v-col>
			<v-col cols="6">
				<v-select v-model="values.operator" :rules="rules" :items="operators" />
			</v-col>
		</v-row>
		<v-row>
			<v-col class="text-center" cols="12">
				<template v-if="options">
					<v-select v-model="values.value" :rules="rules" :items="options" />
				</template>
				<template v-else-if="values.dateType === 'date'">
					<shared-date-field v-model="values.value" label="Date" :rules="rules" />
				</template>
				<template v-else-if="values.dateType === 'day'">
					<v-text-field
						v-model="values.value"
						:rules="dayRules"
						type="number"
					/>
				</template>
			</v-col>
		</v-row>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import strings from "@/utils/strings";

import { DATETIME_OPERATORS_MAP } from "@/services/k4/node/conditionNode";

const initData = () => ({
	dateTypes: [
		{ value: "date", text: "Current date" },
		{ value: "month", text: "Current month" },
		{ value: "weekday", text: "Day of the week" },
		{ value: "day", text: "Day of the month" },
	],

	values: {
		guid: null,
		dateType: "date",
		operator: "==",
		value: null,
	},
});

export default {
	data: initData,

	computed: {
		...mapGetters({
			liveNodeByPath: "controller/nodes/liveNodeByPath",
		}),

		strings() {
			const _strings = strings.live.scenes.dateConditionDialog;
			return _.isNil(this.values.guid) ? _strings.new : _strings.update;
		},

		operators() {
			return _.map(DATETIME_OPERATORS_MAP, (value, key) => ({
				value: key,
				text: value,
			}));
		},

		clockNode() {
			const controllerPath = this.$store.getters["controller/nodes/controller"]
				.path;
			const targetPath = `${controllerPath}/variables/clock/${this.values.dateType}`;
			return this.liveNodeByPath(targetPath);
		},

		rules() {
			return [val => !!val || "Required"];
		},

		dayRules() {
			return [
				val => !!val || "Required",
				val => (val >= 1 && val <= 31) || "Must be between 1 and 31",
			];
		},

		options() {
			return this.clockNode ? this.clockNode.meta().options : null;
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},

		"values.dateType"() {
			this.values.value = null;
		},
	},

	mounted() {
		this.$refs.dialog.updateFormData(this.values);
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},

		pop(handler, node) {
			if (node) {
				this.values.guid = node.guid;
				this.values.operator = node.operator;
				this.values.value = node.value;
				this.values.dateType = _.last(node.targetPath.split("/"));
			}
			return this.$refs.dialog.pop(handler);
		},
	},
};
</script>
